<template>
  <div class="servicesDiv">
    <div>
      <h1
        style="
          font-weight: 800;
          font-size: 40px;
          color: #b5aaa3;
          text-shadow: 0 2px 2px #444;
          text-align: center;
          margin: 3%;
        "
      >
        {{ $t("services") }}
      </h1>
    </div>
    <div class="services">
      <!-- Circular divs for services on the leftDivv -->
      <div class="service-container leftDivv">
        <div
          class="circle service"
          v-for="(service, index) in services.slice(0, 3)"
          :key="index"
        >
          <div class="row serviceRowContainer">
            <div class="col-10">
              <div class="row">
                <h5
                  :class="{
                    'serviceName serviceNameLeft': langVar === 'ar',
                    'serviceName serviceNameLeft serviceNameLeftEn':
                      langVar === 'en',
                  }"
                >
                  {{ service.name }}
                </h5>
              </div>
              <div class="row" :class="{
                'serviceDesc serviceDescLeft': langVar === 'ar',
                'serviceDesc serviceDescLeft serviceDescLeftEn':
                  langVar === 'en',
              }">
                <p
                  
                >
                  {{ service.description }}
                </p>
              </div>
            </div>
            <div class="col-2 d-none d-md-block">
              <i
                :class="service.thumb"
                style="font-size: 70px; color: #fcd16d"
                class="thumbb"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Circular image in the middle -->
      <div class="center">
        <img
          src="../../assets/images/services.png"
          alt="Service Image"
          class="serviceImg"
        />
      </div>

      <!-- Circular divs for services on the right -->
      <div class="service-container rightDivv">
        <div
          class="circle service"
          v-for="(service, index) in services.slice(3, 6)"
          :key="index"
        >
          <div class="row serviceRowContainer">
            <div class="col-2 d-none d-md-block">
              <i
                :class="service.thumb"
                style="font-size: 70px; color: #fcd16d"
                class="thumbb"
              ></i>
            </div>
            <div class="col-10 rightCol">
              <div class="row">
                <h5 class="serviceName">{{ service.name }}</h5>
              </div>
              <div class="row serviceDesc">
                <p>{{ service.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import { mapState } from "vuex";

export default {
  data() {
    return {
      langVar: store.state.currentLang,
      services: [
        {
          thumb: "fa-solid fa-feather",
          name: this.$t("service1"),
          description: this.$t("service1details"),
        },
        {
          thumb: "fa-brands fa-sketch",
          name: this.$t("service2"),
          description: this.$t("service2details"),
        },
        {
          thumb: "fa-solid fa-truck-fast",
          name: this.$t("service3"),
          description: this.$t("service3details"),
        },
        {
          thumb: "fa-solid fa-hand-holding-dollar",
          name: this.$t("service4"),
          description: this.$t("service4details"),
        },
        {
          thumb: "fa-solid fa-cubes",
          name: this.$t("service5"),
          description: this.$t("service5details"),
        },
        {
          thumb: "fa-solid fa-award",
          name: this.$t("service6"),
          description: this.$t("service6details"),
        },
      ],
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
};
</script>

<style scoped>
.services {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  color: #4a4a49;
  margin-right: -5%;
}

.service-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.services {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: #f3f1f0;
}

.thumbb {
  z-index: -1;
}

.serviceImg {
  width: 50% !important;
}

/* leftDivv container for services */
.leftDivv {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.serviceNameLeft {
  margin-right: 50%;
}

.serviceNameLeftEn {
  text-align: left;
  padding-left: 50%;
}

.serviceDescLeft {
  margin-right: 30%;
}

.serviceDescLeftEn {
  text-align: left;
}

/* Center container for the image */
.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -5%;
}

.center > img {
  width: 75%;
}

/* Right container for services */
.rightDivv {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}
.rightCol{
  padding-right: 8%;
}
.serviceName {
  font-weight: 900;
  text-shadow: 0 0.5px 0px #4a4a49;
  z-index: 100;
}
.serviceDesc {
  font-size: 15px;
  width: 70%;
}

.service:nth-child(2) {
  margin: 10%;
}

@media (max-width: 820px) {
  .rightCol{
    padding-right: 0;
  }
  .services{
    background: none;
    margin: 0;
  }
  .servicesDiv {
    margin: 0;
    padding: 0;
    background-image: url("../../assets/images/background.png");
    background-repeat: no-repeat;
  }
  .service {
    background-color: #e5ded9;
    border-radius: 25px;
    width: 100%;
    background-image: url("../../assets/images/logo3.png");
    background-size: 50%;
    background-position-x: 20%;
    background-position-y: 15%;
    background-repeat: no-repeat;
    padding: 2%;
  }
  
  .serviceDesc {
    font-size: 14px;
    margin: 0;
    text-align: center;
    height: 130px;
  }
  .serviceName {
    margin: 0;
    font-size: 16px;
    text-align: center;
    margin-top: 20%;
    padding-left: 30%;
  }
  .center {
    display: none;
  }
  .thumbb {
    display: none;
  }
  .serviceRowContainer{
    height: 200px;
  }
  
}

@media (max-width: 750px) {
  .serviceDesc{
    width: 120%;
  }
  .serviceName{
    padding-right: 20%;
    padding-left: 0;
  }
  .serviceRowContainer{
    height: 280px;
  }
}
</style>